module.exports = __webpack_public_path__ + "img/gb861_2.prt.ba513adc.jpg";